import React from 'react'
import { FlexCenter, Padding } from '../../../styles/CommonStyles'
import { DetailText } from '../../../styles/TransactionHistoryStyles'
import { Text } from '../../../modules/staking'
import { ItemRow } from '../../../styles/newStyles/MobileModal.styled'
import { SOCKET_URL } from '../../../core/constants/urls'
import { formatDate, formatNumber } from '../../../core/utils/common'
import { usePersianNames } from '../../../pages/trade/utils'

const P2PTradeDetailsModal = ({ data, profileId, onClose }) => {
    const { findPersianName } = usePersianNames()

    const tradeType = profileId !== data.order?.userId
        ? (data.order?.type === 'buy' ? 'sell' : 'buy')
        : data.order?.type

    return (
        <div>
            <FlexCenter width='100%'>
                <Padding padding='10px 0' style={{ borderBottom: '1px solid #ffffff15' }}>
                    <DetailText>
                        <Text tid='see-details' />
                    </DetailText>
                </Padding>
            </FlexCenter>
            <div className='p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4'>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='date' className='text-pcolor-light text-sm' />
                    {formatDate(data.createdAt, 'date', 'fa-IR')}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='market' className='text-pcolor-light text-sm' />
                    <FlexCenter>
                        <img
                            src={SOCKET_URL + `assets/icon/${data?.coin?.toLowerCase()}.png`}
                            alt={data?.coin}
                            className='w-6 h-6 mr-2'
                        />
                        {`${data.coin?.toUpperCase()} / ${data.pair?.toUpperCase()}`}
                    </FlexCenter>
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='type' className='text-pcolor-light text-sm' />
                    <Text tid={tradeType} className={tradeType === 'buy' ? 'text-green-400' : 'text-red-400'} />
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='submit' className='text-pcolor-light text-sm' />
                    {data.order?.submit}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='order-amount' className='text-pcolor-light text-sm' />
                    {formatNumber(data.order?.amount, { type: data.coin })}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='unit-price' className='text-pcolor-light text-sm' />
                    {formatNumber(data.order?.priceUnit, { type: data.pair })}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='total-price' className='text-pcolor-light text-sm' />
                    {formatNumber(data.order?.price, { type: data.pair })}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='filled-amount' className='text-pcolor-light text-sm' />
                    {formatNumber(data.order?.tradedAmount, { type: data.coin })}
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='fee' className='text-pcolor-light text-sm' />
                    0
                </ItemRow>
                <ItemRow>
                    <Text tid='status' className='text-pcolor-light text-sm' />
                    {data.order?.status}
                </ItemRow>
            </div>
        </div>
    )
}

export default P2PTradeDetailsModal
